import { assignmentErrorMessages } from '@repo/lib/messages/assignmentErrorMessages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { SubmitAssignmentInput } from './assignmentService';

import { AssignmentService } from './assignmentService';
import { AssignmentKey } from './keys';

export function useSubmitAssignment() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: SubmitAssignmentInput) => AssignmentService.submitAssignment(input).then((response) => response.data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [AssignmentKey.ASSIGNMENT_SUBMISSIONS, variables.assignmentId],
      });
      queryClient.invalidateQueries({
        queryKey: [AssignmentKey.ASSIGNMENT, variables.assignmentId],
      });
    },
  });

  const errorMessage = useErrorMessage(mutation.error, assignmentErrorMessages);

  return { ...mutation, errorMessage };
}
